import { apiGet } from './default'

function getDescription(conids) {
    return apiGet(`/portal.proxy/v1/mkt/trsrv/secdef?conids=${conids}`);
}

export default {
    getDescription
}
